import React, { FC, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { redirectTo } from 'omni-package-react-core';
import Constants from '../../../../../Constants';
import { Pagination } from '../../../../../interfaces/Pagination';
import { StyledPagination } from './Navigation.styles';

export interface NavigationProps {
  pagination: Pagination;
}

const MessagesNavigation: FC<NavigationProps> = ({ pagination }) => {
  const navigate = useNavigate();
  const { search } = useLocation();

  const urlSearchParams = new URLSearchParams(search);
  const messageSource = urlSearchParams.get('messageSource');

  const handlePagePrevious = useCallback(() => {
    redirectTo(`${Constants.MessageDetailsPagePath}/${pagination.previous}?messageSource=${messageSource}`, navigate);
  }, [navigate, messageSource, pagination.previous]);

  const handlePageNext = useCallback(() => {
    redirectTo(`${Constants.MessageDetailsPagePath}/${pagination.next}?messageSource=${messageSource}`, navigate);
  }, [navigate, messageSource, pagination.next]);

  return (
    <StyledPagination
      compact
      name="messagesNavigation"
      itemPerPage={1}
      initialCurrentPage={pagination.pageNumber}
      itemCount={pagination.recordCount}
      onPreviousPage={handlePagePrevious}
      onNextPage={handlePageNext}
    />
  );
};
export default MessagesNavigation;
